import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMochaComponent } from './simple-icons-mocha.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMochaComponent ],
    exports:      [ SimpleIconsMochaComponent ],
    bootstrap:    []
})
export class SimpleIconsMochaModule {}
